export const itemConstants = {
  CREATE_NEW_ITEM: "CREATE_NEW_ITEM",
  CREATE_NEW_ITEM_SUCCESS: "CREATE_NEW_ITEM_SUCCESS",
  CREATE_NEW_ITEM_FAILED: "CREATE_NEW_ITEM_FAILED",

  DELETE_ITEM: "DELETE_ITEM",
  DELETE_ITEM_SUCCESS: "DELETE_ITEM_SUCCESS",
  DELETE_ITEM_FAILED: "DELETE_ITEM_FAILED",

  FETCHING_ITEM: "FETCHING_ITEM",
  FETCH_ITEM_SUCCESS: "FETCH_ITEM_SUCCESS",
  FETCH_ITEM_FAILED: "FETCH_ITEM_FAILED",

  UPDATE_ITEM_DATA_REQUEST: "UPDATE_ITEM_DATA_REQUEST",
  UPDATE_ITEM_DATA_SUCCESS: "UPDATE_ITEM_DATA_SUCCESS",
  UPDATE_ITEM_DATA_FAILURE: "UPDATE_ITEM_DATA_FAILURE",

  FETCH_ITEMS_REQUEST: "FETCH_ITEMS_REQUEST",
  FETCH_ITEMS_SUCCESS: "FETCH_ITEMS_SUCCESS",
  FETCH_ITEMS_FAILURE: "FETCH_ITEMS_FAILURE",

  UPDATE_ITEMS_PASSAGE_REQUEST: "UPDATE_ITEMS_PASSAGE_REQUEST",
  UPDATE_ITEMS_PASSAGE_SUCCESS: "UPDATE_ITEMS_PASSAGE_SUCCESS",
  UPDATE_ITEMS_PASSAGE_FAILURE: "UPDATE_ITEMS_PASSAGE_FAILURE",

  SYNC_ITEMS_PASSAGE_PREFERENCES_REQUEST:
    "SYNC_ITEMS_PASSAGE_PREFERENCES_REQUEST",
  SYNC_ITEMS_PASSAGE_PREFERENCES_SUCCESS:
    "SYNC_ITEMS_PASSAGE_PREFERENCES_SUCCESS",
  SYNC_ITEMS_PASSAGE_PREFERENCES_FAILED: "SYNC_ITEMS_PASSAGE_PREFERNCES_FAILED",

  dynamicConsts: function (key = "", type) {
    return {
      request: `UPDATING_${key.toUpperCase()}`,
      success: `${key.toUpperCase()}_UPDATE_SUCCESS`,
      failed: `${key.toUpperCase()}_UPDATE_FAILED`
    }
  }
}
